/* Al Dar Al Shams - Theme JS (lean, no router hijacking) */
(function(){
  'use strict';
  document.addEventListener('DOMContentLoaded', function(){

    // Mobile nav
    var burger = document.querySelector('.burger');
    var mnav = document.querySelector('.mobile-nav');
    if (burger && mnav){
      burger.addEventListener('click', function(){ mnav.classList.add('open'); });
      var close = mnav.querySelector('.mobile-nav__close');
      if (close) close.addEventListener('click', function(){ mnav.classList.remove('open'); });
    }

    // Reveal on scroll
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); obs.unobserve(e.target);} });
    },{threshold:.12});
    document.querySelectorAll('.reveal').forEach(function(el){ obs.observe(el); });

    // Before/After slider
    document.querySelectorAll('.ba-wrap').forEach(function(wrap){
      var after = wrap.querySelector('.ba-after');
      var handle = wrap.querySelector('.ba-handle');
      if(!after || !handle) return;
      var dragging = false;
      function setPos(x){
        var rect = wrap.getBoundingClientRect();
        var pct = Math.max(0, Math.min(100, ((x - rect.left)/rect.width)*100));
        after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        handle.style.left = pct + '%';
      }
      handle.addEventListener('mousedown', function(){ dragging = true; });
      handle.addEventListener('touchstart', function(){ dragging = true; });
      window.addEventListener('mouseup', function(){ dragging = false; });
      window.addEventListener('touchend', function(){ dragging = false; });
      window.addEventListener('mousemove', function(e){ if(dragging) setPos(e.clientX); });
      window.addEventListener('touchmove', function(e){ if(dragging && e.touches[0]) setPos(e.touches[0].clientX); });
      wrap.addEventListener('click', function(e){ setPos(e.clientX); });
    });

    // Project filter
    var filterBar = document.querySelector('.filter-bar');
    if (filterBar){
      filterBar.addEventListener('click', function(e){
        var btn = e.target.closest('button[data-filter]');
        if (!btn) return;
        filterBar.querySelectorAll('button').forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        var f = btn.getAttribute('data-filter');
        document.querySelectorAll('.masonry .m-item').forEach(function(it){
          var cat = it.getAttribute('data-cat') || '';
          it.style.display = (f === 'all' || cat === f) ? '' : 'none';
        });
      });
    }

    // Lightbox
    var lb = document.querySelector('.lightbox');
    if (lb){
      var lbImg = lb.querySelector('img');
      document.querySelectorAll('[data-lightbox]').forEach(function(el){
        el.addEventListener('click', function(){
          var src = el.getAttribute('data-lightbox');
          if (src && src !== ''){ lbImg.src = src; }
          else {
            // use background fallback - capture inner ph color
            lbImg.removeAttribute('src');
          }
          lb.classList.add('open');
        });
      });
      lb.addEventListener('click', function(e){
        if (e.target === lb || e.target.classList.contains('lightbox__close')){
          lb.classList.remove('open');
        }
      });
    }

    // Active nav
    var path = window.location.pathname.replace(/\/$/, '');
    document.querySelectorAll('.nav a, .mobile-nav a').forEach(function(a){
      var href = a.getAttribute('href') || '';
      var hp = href.replace(/\/$/, '');
      if (hp && hp === path) a.classList.add('active');
    });
  });
})();
